import React from "react";
import styled, { keyframes } from "styled-components";
import { BTTO_PROFILE_COLORS } from "../shared/elements";

const shimmer = keyframes`
	0% {
		background-position: 120% 0;
	}
	100% {
		background-position: -120% 0;
	}
`;

const ProfileCardSkeleton = styled.div`
	position: relative;
	width: 100%;
	min-height: 280px;
	border-radius: 12px;
	overflow: hidden;
	isolation: isolate;
	background: ${BTTO_PROFILE_COLORS.surface};
	border: 1px solid ${BTTO_PROFILE_COLORS.border};

	@media (min-width: 768px) {
		min-height: 320px;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		background: linear-gradient(
			110deg,
			transparent 30%,
			rgba(255, 255, 255, 0.06) 50%,
			transparent 70%
		);
		background-size: 220% 100%;
		animation: ${shimmer} 1.8s ease-in-out infinite;
		pointer-events: none;
	}

	@media (prefers-reduced-motion: reduce) {
		&::after {
			animation: none;
			opacity: 0.35;
		}
	}
`;

export const BettoProfileCardSkeleton = () => <ProfileCardSkeleton aria-hidden="true" />;
